import padZeroEnd from './utils/padZeroEnd';
import separateThousands from './utils/separateThousands';
import isNumber from './utils/isNumber';

/***
 * Converts user input to the Dutch formatted version of number.
 *
 * @deprecated as we are only keeping this for backwards compatibility with
 * pre typescript conversion usages. Please use `getFormattedNumber` instead
 *
 * @param value
 * @param [decimalCount] by default leaves the decimals part unchanged.
 * Passing in the decimals will either trim or pad the decimals part of the number being formatted
 */
export default function number(value: any, decimalCount: number = -1): string {
  // If we're dealing with anything other than a number, don't do anything, return it as is.
  if (!isNumber(value)) {
    return value;
  }

  const split = String(value).split('.');
  let digits = split[0];
  const decimals = padZeroEnd(split[1] || '', decimalCount);

  digits = digits.replace(/[^\d-]/g, '').replace(/^([-]?)\./, '$1');

  return separateThousands(digits) + (decimals.length > 0 ? `,${decimals}` : '');
}
